var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoggedIn)?_c('LoggedInLayout',{attrs:{"guide":_vm.guide}}):_c('LoggedOutLayout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }